import { render, staticRenderFns } from "./RegionalAnalyticsActiveBacklog.vue?vue&type=template&id=33f8e75d&"
import script from "./RegionalAnalyticsActiveBacklog.vue?vue&type=script&lang=js&"
export * from "./RegionalAnalyticsActiveBacklog.vue?vue&type=script&lang=js&"
import style0 from "./RegionalAnalyticsActiveBacklog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports